jQuery( function( $ ) {
    "use strict";

    var setupGalleryKeyboard = function( gallery ) {
        var enhanceThumbnails = function() {
            $( gallery ).find( '.flex-control-thumbs img' ).each( function( index ) {
                var thumbnail = this;
                var labelTemplate = typeof vectorSingleProductData !== 'undefined' && vectorSingleProductData.showImageLabel
                    ? vectorSingleProductData.showImageLabel
                    : 'View product image %d';

                thumbnail.setAttribute( 'role', 'button' );
                thumbnail.setAttribute( 'tabindex', '0' );
                thumbnail.setAttribute( 'aria-label', labelTemplate.replace( '%d', index + 1 ) );
                thumbnail.setAttribute( 'aria-pressed', thumbnail.classList.contains( 'flex-active' ) ? 'true' : 'false' );
            } );
        };

        enhanceThumbnails();

        var observer = new MutationObserver( enhanceThumbnails );
        observer.observe( gallery, {
            attributes: true,
            attributeFilter: [ 'class' ],
            childList: true,
            subtree: true
        } );

        gallery.addEventListener( 'keydown', function( event ) {
            if ( event.target.closest( '.flex-control-thumbs img' ) && ( event.key === ' ' || event.key === 'Spacebar' ) ) {
                event.preventDefault();
            }
        }, true );

        gallery.addEventListener( 'keyup', function( event ) {
            if ( ! event.target.closest( '.flex-control-thumbs img' ) ) {
                return;
            }

            if ( ! [ 'Enter', ' ', 'Spacebar' ].includes( event.key ) ) {
                event.stopPropagation();
            }
        }, true );
    };

    $( '.woocommerce-product-gallery' ).each( function() {
        setupGalleryKeyboard( this );
    } );

    var tabSelect = function() {
        var tabsWrapper = $( '.woocommerce-tabs' );
        var tabs        = tabsWrapper.find( '.vector-product-tabs' );
        var tabLinks    = tabs.find( 'li button' );

        if ( ! tabs.length || ! tabLinks.length ) {
            return;
        }

        var activateTab = function( tab ) {
            var target = tab.attr( 'data-target' );

            if ( ! target || target.charAt( 0 ) !== '#' ) {
                return;
            }

            tabs.find( 'li' ).removeClass( 'active' );
            tabLinks.attr( 'aria-selected', 'false' ).attr( 'tabindex', '0' );
            tabsWrapper.find( '.wc-tab' ).attr( 'hidden', true ).hide();

            tab.closest( 'li' ).addClass( 'active' );
            tab.attr( 'aria-selected', 'true' );
            tabsWrapper.find( target ).removeAttr( 'hidden' ).show();
            $( '#wc-tab-select' ).val( target );
        };

        tabLinks.on( 'click.vectorSingleProductTabs', function( event ) {
            var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

            event.preventDefault();
            activateTab( $( this ) );

            // Keep tab activation from moving the page to the anchor target.
            window.scrollTo( 0, scrollTop );
            window.requestAnimationFrame( function() {
                window.scrollTo( 0, scrollTop );
            } );
        } );

        tabLinks.on( 'focus.vectorSingleProductTabs', function() {
            activateTab( $( this ) );
        } );

        tabLinks.on( 'keydown.vectorSingleProductTabs', function( event ) {
            var direction = event.key;

            if ( ! [ 'ArrowLeft', 'ArrowRight', 'Home', 'End' ].includes( direction ) ) {
                return;
            }

            event.preventDefault();

            var currentIndex = tabLinks.index( this );
            var targetIndex  = currentIndex;

            if ( direction === 'ArrowLeft' ) {
                targetIndex = currentIndex > 0 ? currentIndex - 1 : tabLinks.length - 1;
            } else if ( direction === 'ArrowRight' ) {
                targetIndex = currentIndex < tabLinks.length - 1 ? currentIndex + 1 : 0;
            } else if ( direction === 'Home' ) {
                targetIndex = 0;
            } else if ( direction === 'End' ) {
                targetIndex = tabLinks.length - 1;
            }

            tabLinks.eq( targetIndex ).focus().trigger( 'click' );
        } );

        window.setTimeout( function() {
            activateTab( tabLinks.first() );
        }, 0 );

        $( '<select />', {
            'id'         : 'wc-tab-select',
            'aria-label' : 'Product tabs'
        } ).insertAfter( tabs ).addClass( 'wc-tab-select d-lg-none' );

        tabLinks.each( function() {
            var tab = $( this );

            $( '<option />', {
                'value' : tab.attr( 'data-target' ),
                'text'  : tab.text().trim()
            } ).appendTo( '#wc-tab-select' );
        } );

        $( '#wc-tab-select' ).on( 'change', function() {
            var current = $( this ).find( 'option:selected' ).val();
            var tab     = tabLinks.filter( '[data-target="' + current + '"]' );

            if ( tab.length ) {
                activateTab( tab );
            }
        } );
    };

    tabSelect();
} );



// WEBPACK FOOTER //
// ./resources/assets/scripts/woocommerce-single.js